import { MapPin, ExternalLink } from "lucide-react";

const locations = [
  {
    id: "palazzolo",
    name: "Casa di Cura Palazzolo",
    role: "Responsabile della Radiologia",
    city: "Bergamo",
    note: "Sede unica per Risonanza Magnetica, mammografia (tomosintesi e CESM) ed ecografia. Struttura privata convenzionata; prenotazioni tramite il portale ufficiale.",
    services: ["RM", "Mammografia", "Ecografia"],
    cta: { label: "Prenota su Palazzolo", url: "https://casadicurapalazzolo.it/prenota/" },
  },
  {
    id: "life",
    name: "Life Clinic",
    role: "Specialista ambulatoriale",
    city: "Bergamo",
    note: "Visite ed esami ecografici (addome, collo-tiroide, mammella, muscolo-scheletrica). RM e mammografia non disponibili in questa sede.",
    services: ["Ecografia"],
    cta: {
      label: "Prenota su Life Clinic",
      url: "https://www.life-clinic.it/i-medici/dott-ssa-silvia-dal-bello",
    },
  },
  {
    id: "berbenni",
    name: "Studio Dr. Berbenni",
    role: "Collaborazione senologica",
    city: "Bergamo",
    note: "Ecografia mammaria e percorsi senologici in collaborazione con il Dr. Emanuele Berbenni (Vicepresidente ISOCS). RM e mammografia non disponibili in questa sede.",
    services: ["Ecografia"],
    cta: { label: "Richiedi un appuntamento", url: "#contatti", internal: true },
  },
];

export default function Locations() {
  return (
    <section
      id="sedi"
      data-testid="locations-section"
      className="py-24 lg:py-32 border-t border-stone-200 bg-[#FAFAF9]"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12 lg:px-16">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div>
            <span className="eyebrow">Dove ricevo</span>
            <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-stone-900 leading-[1.1] max-w-2xl">
              Tre sedi a Bergamo per essere vicina al tuo percorso di cura.
            </h2>
          </div>
          <p className="text-stone-600 max-w-md leading-relaxed">
            Ogni struttura ha proprie modalità di prenotazione. Da questa pagina puoi accedere
            direttamente ai canali ufficiali. <strong className="text-stone-900 font-medium">Risonanza Magnetica e mammografia sono disponibili esclusivamente presso la Casa di Cura Palazzolo</strong>; presso Life Clinic e lo studio del Dr. Berbenni eseguo le prestazioni ecografiche.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5 lg:gap-6">
          {locations.map((l) => (
            <article
              key={l.id}
              data-testid={`location-card-${l.id}`}
              className="flex flex-col h-full rounded-2xl border border-stone-200 bg-white p-7 hover:shadow-md transition-shadow duration-300"
            >
              <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-[#3E615B]">
                <MapPin size={14} />
                <span>{l.city}</span>
              </div>
              <h3 className="mt-3 font-display text-xl md:text-2xl font-medium text-stone-900 leading-snug">
                {l.name}
              </h3>
              <p className="mt-1 text-sm text-stone-500">{l.role}</p>

              <div className="mt-4 flex flex-wrap gap-1.5">
                {l.services.map((s) => (
                  <span
                    key={s}
                    className="inline-flex items-center text-[11px] uppercase tracking-[0.14em] px-2.5 py-1 rounded-full bg-[#E9F0EE] text-[#3E615B]"
                  >
                    {s}
                  </span>
                ))}
              </div>

              <p className="mt-5 text-sm text-stone-600 leading-relaxed flex-1">
                {l.note}
              </p>

              <a
                data-testid={`location-cta-${l.id}`}
                href={l.cta.url}
                target={l.cta.internal ? undefined : "_blank"}
                rel={l.cta.internal ? undefined : "noopener noreferrer"}
                className="mt-6 inline-flex items-center justify-between gap-2 rounded-full border border-stone-300 px-5 py-2.5 text-sm text-stone-800 hover:bg-[#3E615B] hover:text-white hover:border-[#3E615B] transition-colors"
              >
                <span>{l.cta.label}</span>
                <ExternalLink size={14} />
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
